import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  HasUidInterface,
  NameableInterface,
  nNumber,
  nString,
  Uuid,
} from '@hidat/huijs-common';
import { ResourceConfig } from '@hidat/huijs-resource';
import { splixerFieldConfigs } from './splixer-fields.const';
import { ExtendedBrandingInterface } from './branded-resource.interface';
import { HashViews } from './hash-views';
import { SplixerResourceTypes } from './splixer-resource-types';

export const StationConfig: ResourceConfig = new ResourceConfig(SplixerResourceTypes.Station)
  .addFields([
    splixerFieldConfigs.intId,
    new FieldConfig('onDemandUrl'),
    new FieldConfig('accessCodes'),
    new FieldConfig('branding', FieldDataTypes.UNKNOWN),
    new FieldConfig('config', FieldDataTypes.UNKNOWN),
    new FieldConfig('defaultPathId', FieldDataTypes.INTEGER),
  ])
  .addFields(
    [
      splixerFieldConfigs.uid,
      splixerFieldConfigs.status,
      splixerFieldConfigs.name,
      splixerFieldConfigs.tagLine,
      splixerFieldConfigs.description,
      new FieldConfig('stationCode'),
      new FieldConfig('timezone'),
      new FieldConfig('accessMode'),
      new FieldConfig('websiteUrl'),
    ],
    true,
    HashViews.player,
  )
  .setSorts({
    name: 'name',
  })
  .setDefaultSort('name');

export interface StationBrandingInterface extends ExtendedBrandingInterface {
  brand_name?: nString;
  brand_url?: nString;
  favicon?: nString;
  ga_code?: nString;
}

export const PlayerStationIncludes = {
  hosts: 'hosts',
  broadcast_programs: 'broadcast_programs',
  featured_mixes: 'featured_mixes',
  recent_mixes: 'recent_mixes',
  genres: 'genres',
  mix_categories: 'mix_categories',
};

export interface StationInterface
  extends SplixerResourceInterface<number>, NameableInterface, HasUidInterface {
  uid: Uuid | undefined;
  stationCode: nString;
  tagLine: nString;
  description: nString;
  branding: ExtendedBrandingInterface | undefined;

  config: AnyHash | undefined;
  timezone: nString;

  defaultPathId: nNumber;
  accessMode: nNumber;
  accessCodes: nString;

  websiteUrl: nString;
  onDemandUrl: nString;

  tenantId: Uuid | undefined;
}
